import { KeyValueList } from '@/components/key-value-list';
import { Card } from '@/shared/ui/card';
import { POD_FACTS } from '../constants';

const ROWS = POD_FACTS.map((fact) => ({
  key: fact.key,
  label: fact.label,
  value: fact.value,
  valueClassName: 'text-muted',
}));

export function PodFactsCard() {
  return (
    <Card asChild>
      <section data-enter="" aria-labelledby="pod-h" className="px-5 pt-4.5 pb-2">
        <h2 id="pod-h" className="font-semibold text-section">
          What every Pod has
        </h2>
        <KeyValueList rows={ROWS} className="mt-1.5" />
      </section>
    </Card>
  );
}
